import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AccountAssetInfo = {
  __typename?: 'AccountAssetInfo';
  DepositAmount: Scalars['String']['output'];
  MarginAmount: Scalars['String']['output'];
  RefundAmount?: Maybe<Scalars['String']['output']>;
  RefundCommission?: Maybe<Scalars['String']['output']>;
  RefundDay?: Maybe<Scalars['String']['output']>;
  TotalAssets: Scalars['String']['output'];
  UpdTime: Scalars['String']['output'];
  WithdrawableAmount: Scalars['String']['output'];
  WithdrawalCommission?: Maybe<Scalars['String']['output']>;
  WithdrawalDay?: Maybe<Scalars['String']['output']>;
  WithdrawalReservation?: Maybe<Scalars['String']['output']>;
};

export type AccountDetailInfo = {
  __typename?: 'AccountDetailInfo';
  AccountNumber: Scalars['String']['output'];
  AmericanOnTaxSystem?: Maybe<Scalars['Boolean']['output']>;
  AnnualIncome: Scalars['Int']['output'];
  BankCode: Scalars['String']['output'];
  Birthday?: Maybe<Scalars['String']['output']>;
  BranchCode: Scalars['String']['output'];
  BuildingNameRoomNumber?: Maybe<Scalars['String']['output']>;
  CityCounty: Scalars['String']['output'];
  Department?: Maybe<Scalars['String']['output']>;
  DepositForm: Scalars['Int']['output'];
  FATCAAgreement?: Maybe<Scalars['Boolean']['output']>;
  FATCAOath?: Maybe<Scalars['Boolean']['output']>;
  FinancialAssets: Scalars['Int']['output'];
  FirstName: Scalars['String']['output'];
  FirstNameKana: Scalars['String']['output'];
  HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  ITIN?: Maybe<Scalars['String']['output']>;
  IncomeForm: Array<Maybe<Scalars['Int']['output']>>;
  InsiderBoardMemberFirstName?: Maybe<Scalars['String']['output']>;
  InsiderBoardMemberLastName?: Maybe<Scalars['String']['output']>;
  InvestmentExperiences: Array<Maybe<Scalars['Int']['output']>>;
  InvestmentPolicy: Scalars['Int']['output'];
  InvestmentPurposes: Array<Maybe<Scalars['Int']['output']>>;
  LastName: Scalars['String']['output'];
  LastNameKana: Scalars['String']['output'];
  ListedCompanyCheck: Scalars['Boolean']['output'];
  ListedCompanyName?: Maybe<Scalars['String']['output']>;
  ListedCompanyPost?: Maybe<Scalars['Int']['output']>;
  MailAddress?: Maybe<Scalars['String']['output']>;
  MobilePhoneNumber: Scalars['String']['output'];
  Nationality: Scalars['Int']['output'];
  OutSidePost?: Maybe<Scalars['String']['output']>;
  Post?: Maybe<Scalars['String']['output']>;
  PostCode: Scalars['String']['output'];
  Prefecture: Scalars['String']['output'];
  Profession: Scalars['Int']['output'];
  RetirementDate?: Maybe<Scalars['String']['output']>;
  SSN?: Maybe<Scalars['String']['output']>;
  Sex?: Maybe<Scalars['Int']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
  WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  Workplace?: Maybe<Scalars['String']['output']>;
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  Account: Scalars['String']['output'];
  ChangedPassword: Scalars['Boolean']['output'];
  DepositAmount: Scalars['String']['output'];
  FinancialIntermediaryInvitation?: Maybe<Scalars['Boolean']['output']>;
  LastLoginDateTime?: Maybe<Scalars['String']['output']>;
  MFASetupStatus?: Maybe<Scalars['Int']['output']>;
  MarginAmount: Scalars['String']['output'];
};

export type AccountTransaction = {
  __typename?: 'AccountTransaction';
  AmountDeposit?: Maybe<Scalars['Int']['output']>;
  AmountPayment?: Maybe<Scalars['Int']['output']>;
  AmountTransfer?: Maybe<Scalars['Int']['output']>;
  Credit?: Maybe<Scalars['String']['output']>;
  Debit?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  TransactionDate: Scalars['String']['output'];
  TransactionTypeName: Scalars['String']['output'];
  WithdrawalType?: Maybe<Scalars['Int']['output']>;
};

export type AccountTransactionHistory = {
  __typename?: 'AccountTransactionHistory';
  Data?: Maybe<Array<Maybe<AccountTransaction>>>;
  TotalCount: Scalars['Int']['output'];
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  CityCounty?: Maybe<Scalars['String']['output']>;
  Prefecture?: Maybe<Scalars['String']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
};

export type AgreeDocumentParam = {
  Types: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type AgreementDocumentInfo = {
  __typename?: 'AgreementDocumentInfo';
  Read: Scalars['Boolean']['output'];
  Type: Scalars['Int']['output'];
  URL: Scalars['String']['output'];
};

export type AgreementDocumentList = {
  __typename?: 'AgreementDocumentList';
  Data?: Maybe<Array<Maybe<AgreementDocumentInfo>>>;
};

export type ApplicationDetailInfo = {
  __typename?: 'ApplicationDetailInfo';
  ID: Scalars['String']['output'];
  LatestApplicationDateTime: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TotalApplicationQuantity: Scalars['Int']['output'];
  TotalPurchaseQuantity: Scalars['Int']['output'];
};

export type ApplicationInfo = {
  __typename?: 'ApplicationInfo';
  ID: Scalars['String']['output'];
  LatestApplicationDateTime: Scalars['String']['output'];
  LotteryFailureRefundType: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TotalApplicationQuantity: Scalars['Int']['output'];
  TotalPurchaseAmount: Scalars['Int']['output'];
  TotalPurchaseQuantity: Scalars['Int']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  Data?: Maybe<Array<Maybe<ApplicationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type ApplySymbolParam = {
  IntermediaryData?: InputMaybe<FinancialIntermediaryData>;
  Quantity: Scalars['Int']['input'];
  RefundType?: InputMaybe<Scalars['Int']['input']>;
  Symbol: Scalars['String']['input'];
};

export type AuthInfo = {
  __typename?: 'AuthInfo';
  AAGUID?: Maybe<Scalars['String']['output']>;
  AuthName?: Maybe<Scalars['String']['output']>;
  CreatedAt: Scalars['String']['output'];
  CredentialID: Scalars['String']['output'];
  IconData?: Maybe<Scalars['String']['output']>;
};

export type BrokerInfo = {
  __typename?: 'BrokerInfo';
  BranchCode?: Maybe<Scalars['String']['output']>;
  BranchName?: Maybe<Scalars['String']['output']>;
  BrokerCode?: Maybe<Scalars['String']['output']>;
  BrokerName?: Maybe<Scalars['String']['output']>;
};

export type BrokerList = {
  __typename?: 'BrokerList';
  Data?: Maybe<Array<Maybe<BrokerInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type CancelWithdrawalParam = {
  CheckMode: Scalars['Boolean']['input'];
};

export type ChangeAccountInfoParam = {
  AccountNumber?: InputMaybe<Scalars['String']['input']>;
  AmericanOnTaxSystem?: InputMaybe<Scalars['Boolean']['input']>;
  AnnualIncome?: InputMaybe<Scalars['Int']['input']>;
  BankCode?: InputMaybe<Scalars['String']['input']>;
  Birthday?: InputMaybe<Scalars['String']['input']>;
  BranchCode?: InputMaybe<Scalars['String']['input']>;
  BuildingNameRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CityCounty?: InputMaybe<Scalars['String']['input']>;
  Department?: InputMaybe<Scalars['String']['input']>;
  DepositForm?: InputMaybe<Scalars['Int']['input']>;
  FATCAAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  FATCAOath?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialAssets?: InputMaybe<Scalars['Int']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  FirstNameKana?: InputMaybe<Scalars['String']['input']>;
  HomePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ITIN?: InputMaybe<Scalars['String']['input']>;
  IncomeForm?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  InsiderBoardMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  InsiderBoardMemberLastName?: InputMaybe<Scalars['String']['input']>;
  InvestmentExperiences?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  InvestmentPolicy?: InputMaybe<Scalars['Int']['input']>;
  InvestmentPurposes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LastNameKana?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyCheck?: InputMaybe<Scalars['Boolean']['input']>;
  ListedCompanyName?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyPost?: InputMaybe<Scalars['Int']['input']>;
  MailAddress?: InputMaybe<Scalars['String']['input']>;
  MobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  Nationality?: InputMaybe<Scalars['Int']['input']>;
  OutSidePost?: InputMaybe<Scalars['String']['input']>;
  Post?: InputMaybe<Scalars['String']['input']>;
  PostCode?: InputMaybe<Scalars['String']['input']>;
  Prefecture?: InputMaybe<Scalars['String']['input']>;
  Profession?: InputMaybe<Scalars['Int']['input']>;
  RetirementDate?: InputMaybe<Scalars['String']['input']>;
  SSN?: InputMaybe<Scalars['String']['input']>;
  Sex?: InputMaybe<Scalars['Int']['input']>;
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  WorkPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  Workplace?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeAccountInfoResult = {
  __typename?: 'ChangeAccountInfoResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  WithEKYC?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordParam = {
  CurrentPassword: Scalars['String']['input'];
  NewPassword: Scalars['String']['input'];
};

export type DateTimeInfo = {
  __typename?: 'DateTimeInfo';
  Current?: Maybe<Scalars['String']['output']>;
};

export type ExecuteResult = {
  __typename?: 'ExecuteResult';
  AdditionalMessage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
};

export type FinancialIntermediaryData = {
  FPGSecIntermediaryExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialIntermediary?: InputMaybe<Scalars['Int']['input']>;
  FinancialIntermediaryExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialIntermediaryInvitation: Scalars['Boolean']['input'];
  ManagerCode?: InputMaybe<Scalars['String']['input']>;
};

export type GetListAuthsResult = {
  __typename?: 'GetListAuthsResult';
  AvailableAuthList?: Maybe<Array<Maybe<AuthInfo>>>;
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
};

export type GetNegotiateTokenResult = {
  __typename?: 'GetNegotiateTokenResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  NegotiateToken?: Maybe<Scalars['String']['output']>;
};

export type InquiryParam = {
  Content?: InputMaybe<Scalars['String']['input']>;
};

export type IssuanceDocument = {
  __typename?: 'IssuanceDocument';
  Data: Scalars['String']['output'];
};

export type IssuanceDocumentInfo = {
  __typename?: 'IssuanceDocumentInfo';
  DisplayName: Scalars['String']['output'];
  FileName: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  IssueDate: Scalars['String']['output'];
};

export type IssuanceDocumentList = {
  __typename?: 'IssuanceDocumentList';
  Data?: Maybe<Array<Maybe<IssuanceDocumentInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type LoginParam = {
  Account: Scalars['String']['input'];
  Password: Scalars['String']['input'];
};

export type LoginResult = {
  __typename?: 'LoginResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type MfaLoginParam = {
  Account: Scalars['String']['input'];
  AuthencicateToken: Scalars['String']['input'];
  CodeVerifier: Scalars['String']['input'];
  RedirectURL: Scalars['String']['input'];
};

export type MfaLoginResult = {
  __typename?: 'MFALoginResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  Token?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AgreeDocument?: Maybe<ExecuteResult>;
  ApplySymbol?: Maybe<ExecuteResult>;
  CancelWithdrawal?: Maybe<RequestWithdrawalResult>;
  ChangeAccountInfo?: Maybe<ChangeAccountInfoResult>;
  ChangePassword?: Maybe<ExecuteResult>;
  Inquiry?: Maybe<ExecuteResult>;
  Login?: Maybe<LoginResult>;
  Logout?: Maybe<ExecuteResult>;
  MFALogin?: Maybe<MfaLoginResult>;
  OpenAccount?: Maybe<ExecuteResult>;
  ReadNotification?: Maybe<ExecuteResult>;
  ReissuePassword?: Maybe<ReissuePasswordResult>;
  RequestWithdrawal?: Maybe<RequestWithdrawalResult>;
  SMSCertificate?: Maybe<SmsCertificateResult>;
  SendSMS?: Maybe<SendSmsResult>;
  UpdateAccountAsset?: Maybe<AccountAssetInfo>;
  UpdateMFASetupStatus?: Maybe<UpdateMfaStatusResult>;
};


export type MutationAgreeDocumentArgs = {
  input?: InputMaybe<AgreeDocumentParam>;
};


export type MutationApplySymbolArgs = {
  input?: InputMaybe<ApplySymbolParam>;
};


export type MutationCancelWithdrawalArgs = {
  input?: InputMaybe<CancelWithdrawalParam>;
};


export type MutationChangeAccountInfoArgs = {
  input?: InputMaybe<ChangeAccountInfoParam>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordParam>;
};


export type MutationInquiryArgs = {
  input?: InputMaybe<InquiryParam>;
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginParam>;
};


export type MutationMfaLoginArgs = {
  input?: InputMaybe<MfaLoginParam>;
};


export type MutationOpenAccountArgs = {
  input?: InputMaybe<OpenAccountParam>;
};


export type MutationReadNotificationArgs = {
  input?: InputMaybe<ReadNotificationParam>;
};


export type MutationReissuePasswordArgs = {
  input?: InputMaybe<ReissuePasswordParam>;
};


export type MutationRequestWithdrawalArgs = {
  input?: InputMaybe<RequestWithdrawalParam>;
};


export type MutationSmsCertificateArgs = {
  input?: InputMaybe<SmsCertificateParam>;
};


export type MutationSendSmsArgs = {
  input?: InputMaybe<SendSmsParam>;
};


export type MutationUpdateMfaSetupStatusArgs = {
  input?: InputMaybe<UpdateMfaStatusParam>;
};

export type NotificationDetailInfo = {
  __typename?: 'NotificationDetailInfo';
  ConfirmDateTime?: Maybe<Scalars['String']['output']>;
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  Contents: Scalars['String']['output'];
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Importance: Scalars['Int']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationInfo = {
  __typename?: 'NotificationInfo';
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Importance: Scalars['Int']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationList = {
  __typename?: 'NotificationList';
  Data?: Maybe<Array<Maybe<NotificationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type OmegaFsSsoParam = {
  __typename?: 'OmegaFsSsoParam';
  Buten: Scalars['String']['output'];
  GamenID: Scalars['String']['output'];
  GamenParm: Scalars['String']['output'];
  Kaiin: Scalars['String']['output'];
  MenuDispFlg: Scalars['String']['output'];
  ResultKensho: Scalars['String']['output'];
  ShoriHMS: Scalars['String']['output'];
  ShoriYMD: Scalars['String']['output'];
  UserCd: Scalars['String']['output'];
};

export type OpenAccountParam = {
  AccountNumber: Scalars['String']['input'];
  AgeConfirmation: Scalars['Boolean']['input'];
  AmericanOnTaxSystem?: InputMaybe<Scalars['Boolean']['input']>;
  AnnualIncome: Scalars['Int']['input'];
  AntiSocialForcesCheckAgreement: Scalars['Boolean']['input'];
  BankCode: Scalars['String']['input'];
  Birthday: Scalars['String']['input'];
  BranchCode: Scalars['String']['input'];
  BuildingNameRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CityCounty: Scalars['String']['input'];
  Department: Scalars['String']['input'];
  DepositForm: Scalars['Int']['input'];
  DistributionStatementAgreement: Scalars['Boolean']['input'];
  ElectronicDocumentAgreement: Scalars['Boolean']['input'];
  ElectronicDocumentAgreementDateTime?: InputMaybe<Scalars['String']['input']>;
  FATCAAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  FATCAOath?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialAssets: Scalars['Int']['input'];
  FinancialIntermediary?: InputMaybe<Scalars['Int']['input']>;
  FinancialIntermediaryExplanation: Scalars['Boolean']['input'];
  FinancialIntermediaryInvitation: Scalars['Boolean']['input'];
  FirstName: Scalars['String']['input'];
  FirstNameKana: Scalars['String']['input'];
  HomePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  IDConfirmation: Scalars['Boolean']['input'];
  ITIN?: InputMaybe<Scalars['String']['input']>;
  IncomeForm: Array<InputMaybe<Scalars['Int']['input']>>;
  InformationSharingAgreement: Scalars['Boolean']['input'];
  InsiderBoardMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  InsiderBoardMemberLastName?: InputMaybe<Scalars['String']['input']>;
  InvestmentExperiences: Array<InputMaybe<Scalars['Int']['input']>>;
  InvestmentPolicy: Scalars['Int']['input'];
  InvestmentPurposes: Array<InputMaybe<Scalars['Int']['input']>>;
  LastName: Scalars['String']['input'];
  LastNameKana: Scalars['String']['input'];
  ListedCompanyCheck: Scalars['Boolean']['input'];
  ListedCompanyName?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyPost?: InputMaybe<Scalars['Int']['input']>;
  MailAddress?: InputMaybe<Scalars['String']['input']>;
  ManagerCode?: InputMaybe<Scalars['String']['input']>;
  MobilePhoneNumber: Scalars['String']['input'];
  Nationality: Scalars['Int']['input'];
  OutSidePost?: InputMaybe<Scalars['String']['input']>;
  PEPsConfirmation: Scalars['Boolean']['input'];
  Post: Scalars['String']['input'];
  PostCode: Scalars['String']['input'];
  PreContractAgreement: Scalars['Boolean']['input'];
  Prefecture: Scalars['String']['input'];
  Profession: Scalars['Int']['input'];
  ResidenceConfirmation: Scalars['Boolean']['input'];
  RetirementDate?: InputMaybe<Scalars['String']['input']>;
  SSN?: InputMaybe<Scalars['String']['input']>;
  SecuritiesTradingTermsAgreement: Scalars['Boolean']['input'];
  Sex: Scalars['Int']['input'];
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  WorkPhoneNumber: Scalars['String']['input'];
  Workplace: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  GetAccountDetailInfo?: Maybe<AccountDetailInfo>;
  GetAccountInfo?: Maybe<AccountInfo>;
  GetAccountTransactionHistory?: Maybe<AccountTransactionHistory>;
  GetAddressInfo?: Maybe<AddressInfo>;
  GetAgreementDocument?: Maybe<AgreementDocumentList>;
  GetAgreementDocumentList?: Maybe<AgreementDocumentList>;
  GetApplicationInfo?: Maybe<ApplicationDetailInfo>;
  GetApplicationList?: Maybe<ApplicationList>;
  GetBrokerBranchInfo?: Maybe<BrokerList>;
  GetBrokerInfo?: Maybe<BrokerList>;
  GetBrokerMaster?: Maybe<BrokerInfo>;
  GetDateTime?: Maybe<DateTimeInfo>;
  GetIssuanceDocument?: Maybe<IssuanceDocument>;
  GetIssuanceDocumentList?: Maybe<IssuanceDocumentList>;
  GetListAuths?: Maybe<GetListAuthsResult>;
  GetNegotiateToken?: Maybe<GetNegotiateTokenResult>;
  GetNotificationInfo?: Maybe<NotificationDetailInfo>;
  GetNotificationList?: Maybe<NotificationList>;
  GetOmegaFsSsoParam?: Maybe<OmegaFsSsoParam>;
  GetSymbolInfo?: Maybe<SymbolDetailInfo>;
  GetSymbolList?: Maybe<SymbolList>;
  GetVirtualAccountInfo?: Maybe<VirtualAccountInfo>;
};


export type QueryGetAccountTransactionHistoryArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetAddressInfoArgs = {
  postCode: Scalars['String']['input'];
};


export type QueryGetApplicationInfoArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApplicationListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerBranchInfoArgs = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  brokerCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerInfoArgs = {
  brokerCode?: InputMaybe<Scalars['String']['input']>;
  brokerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerMasterArgs = {
  branchCode: Scalars['String']['input'];
  brokerCode: Scalars['String']['input'];
};


export type QueryGetIssuanceDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIssuanceDocumentListArgs = {
  count: Scalars['Int']['input'];
  documentType?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetNegotiateTokenArgs = {
  account?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNotificationInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNotificationListArgs = {
  count: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetSymbolInfoArgs = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSymbolListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
};

export type ReadNotificationParam = {
  ID?: InputMaybe<Scalars['String']['input']>;
};

export type ReissuePasswordParam = {
  Account: Scalars['String']['input'];
  PhoneNumber: Scalars['String']['input'];
};

export type ReissuePasswordResult = {
  __typename?: 'ReissuePasswordResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type RequestWithdrawalParam = {
  Amount: Scalars['String']['input'];
  CheckMode: Scalars['Boolean']['input'];
};

export type RequestWithdrawalResult = {
  __typename?: 'RequestWithdrawalResult';
  Code: Scalars['Int']['output'];
  Commission: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  PrevRequestedWithdrawalAmount?: Maybe<Scalars['Int']['output']>;
  RequestedWithdrawalAmount: Scalars['Int']['output'];
  WithdrawalAmount: Scalars['Int']['output'];
  WithdrawalDate: Scalars['String']['output'];
};

export type SmsCertificateParam = {
  AuthenticationCode: Scalars['String']['input'];
  ProvisionalToken: Scalars['String']['input'];
  Type: Scalars['Int']['input'];
};

export type SmsCertificateResult = {
  __typename?: 'SMSCertificateResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Token?: Maybe<Scalars['String']['output']>;
};

export type SendSmsParam = {
  Account?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ProvisionalToken?: InputMaybe<Scalars['String']['input']>;
  Type: Scalars['Int']['input'];
};

export type SendSmsResult = {
  __typename?: 'SendSMSResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type SymbolDetailInfo = {
  __typename?: 'SymbolDetailInfo';
  CurrentPrice: Scalars['Float']['output'];
  ExpectedInterestRate: Scalars['Float']['output'];
  Explanation: Scalars['String']['output'];
  ImageUrl: Scalars['String']['output'];
  OperationEndDate: Scalars['String']['output'];
  OperationStartDate: Scalars['String']['output'];
  Overview: Scalars['String']['output'];
  PreContractDocumentUrl: Scalars['String']['output'];
  PricePerUnit: Scalars['Float']['output'];
  ProspectusUrl: Scalars['String']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TradeEndDate: Scalars['String']['output'];
  TradeStartDate: Scalars['String']['output'];
};

export type SymbolInfo = {
  __typename?: 'SymbolInfo';
  CurrentPrice: Scalars['Float']['output'];
  ExpectedInterestRate: Scalars['Float']['output'];
  ImageUrl: Scalars['String']['output'];
  OperationEndDate: Scalars['String']['output'];
  OperationStartDate: Scalars['String']['output'];
  Overview: Scalars['String']['output'];
  PricePerUnit: Scalars['Float']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TradeEndDate: Scalars['String']['output'];
  TradeStartDate: Scalars['String']['output'];
};

export type SymbolList = {
  __typename?: 'SymbolList';
  Data?: Maybe<Array<Maybe<SymbolInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type UpdateMfaStatusParam = {
  Status: Scalars['Int']['input'];
};

export type UpdateMfaStatusResult = {
  __typename?: 'UpdateMFAStatusResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
};

export type VirtualAccountInfo = {
  __typename?: 'VirtualAccountInfo';
  AccountHolder: Scalars['String']['output'];
  AccountHolderKana: Scalars['String']['output'];
  AccountNumber: Scalars['String']['output'];
  AccountType: Scalars['String']['output'];
  BankCode: Scalars['String']['output'];
  BankName: Scalars['String']['output'];
  BranchCode: Scalars['String']['output'];
  BranchName: Scalars['String']['output'];
};

export type LoginMutationVariables = Exact<{
  input?: InputMaybe<LoginParam>;
}>;


export type LoginMutation = { __typename?: 'Mutation', Login?: { __typename?: 'LoginResult', Code: number, Message?: string | null, ProvisionalToken?: string | null, PhoneNumber?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', Logout?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input?: InputMaybe<ReadNotificationParam>;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', ReadNotification?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type SmsCertificateMutationVariables = Exact<{
  input?: InputMaybe<SmsCertificateParam>;
}>;


export type SmsCertificateMutation = { __typename?: 'Mutation', SMSCertificate?: { __typename?: 'SMSCertificateResult', Code: number, Message?: string | null, Token?: string | null } | null };

export type SendSmsMutationVariables = Exact<{
  input?: InputMaybe<SendSmsParam>;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', SendSMS?: { __typename?: 'SendSMSResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type GetSymbolListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSymbolListQuery = { __typename?: 'Query', GetSymbolList?: { __typename?: 'SymbolList', TotalCount: number, Data?: Array<{ __typename?: 'SymbolInfo', Symbol: string, SymbolName: string, ImageUrl: string, Overview: string, CurrentPrice: number, PricePerUnit: number, ExpectedInterestRate: number, OperationStartDate: string, OperationEndDate: string, Tradable?: boolean | null, TradeStartDate: string, TradeEndDate: string } | null> | null } | null };

export type GetSymbolInfoQueryVariables = Exact<{
  symbol?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSymbolInfoQuery = { __typename?: 'Query', GetSymbolInfo?: { __typename?: 'SymbolDetailInfo', Symbol: string, SymbolName: string, ImageUrl: string, Overview: string, Explanation: string, CurrentPrice: number, PricePerUnit: number, ExpectedInterestRate: number, ProspectusUrl: string, PreContractDocumentUrl: string, OperationStartDate: string, OperationEndDate: string, Tradable?: boolean | null, TradeStartDate: string, TradeEndDate: string } | null };

export type ApplySymbolMutationVariables = Exact<{
  input?: InputMaybe<ApplySymbolParam>;
}>;


export type ApplySymbolMutation = { __typename?: 'Mutation', ApplySymbol?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null, AdditionalMessage?: Array<string | null> | null } | null };

export type OpenAccountMutationVariables = Exact<{
  input?: InputMaybe<OpenAccountParam>;
}>;


export type OpenAccountMutation = { __typename?: 'Mutation', OpenAccount?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetApplicationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationListQuery = { __typename?: 'Query', GetApplicationList?: { __typename?: 'ApplicationList', TotalCount: number, Data?: Array<{ __typename?: 'ApplicationInfo', ID: string, LatestApplicationDateTime: string, Status: number, Symbol: string, SymbolName: string, TotalApplicationQuantity: number, TotalPurchaseQuantity: number, TotalPurchaseAmount: number, LotteryFailureRefundType: string } | null> | null } | null };

export type GetApplicationInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationInfoQuery = { __typename?: 'Query', GetApplicationInfo?: { __typename?: 'ApplicationDetailInfo', ID: string, LatestApplicationDateTime: string, Status: number, Symbol: string, SymbolName: string, TotalApplicationQuantity: number, TotalPurchaseQuantity: number } | null };

export type GetNotificationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationListQuery = { __typename?: 'Query', GetNotificationList?: { __typename?: 'NotificationList', TotalCount: number, Data?: Array<{ __typename?: 'NotificationInfo', Confirmed?: boolean | null, DeliveryTarget: number, DeliveryType: number, ID: string, PublishStartDate: string, Title: string, Importance: number } | null> | null } | null };

export type GetAddressInfoQueryVariables = Exact<{
  postCode: Scalars['String']['input'];
}>;


export type GetAddressInfoQuery = { __typename?: 'Query', GetAddressInfo?: { __typename?: 'AddressInfo', CityCounty?: string | null, Prefecture?: string | null, TownStreetAddress?: string | null } | null };

export type GetNotificationInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNotificationInfoQuery = { __typename?: 'Query', GetNotificationInfo?: { __typename?: 'NotificationDetailInfo', ConfirmDateTime?: string | null, Confirmed?: boolean | null, Contents: string, DeliveryTarget: number, DeliveryType: number, ID: string, PublishStartDate: string, Title: string, Importance: number } | null };

export type GetIssuanceDocumentListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  documentType?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIssuanceDocumentListQuery = { __typename?: 'Query', GetIssuanceDocumentList?: { __typename?: 'IssuanceDocumentList', TotalCount: number, Data?: Array<{ __typename?: 'IssuanceDocumentInfo', DisplayName: string, FileName: string, ID: string, IssueDate: string } | null> | null } | null };

export type GetIssuanceDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetIssuanceDocumentQuery = { __typename?: 'Query', GetIssuanceDocument?: { __typename?: 'IssuanceDocument', Data: string } | null };

export type GetBrokerMasterQueryVariables = Exact<{
  brokerCode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
}>;


export type GetBrokerMasterQuery = { __typename?: 'Query', GetBrokerMaster?: { __typename?: 'BrokerInfo', BranchCode?: string | null, BranchName?: string | null, BrokerCode?: string | null, BrokerName?: string | null } | null };

export type GetAccountDetailInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountDetailInfoQuery = { __typename?: 'Query', GetAccountDetailInfo?: { __typename?: 'AccountDetailInfo', AccountNumber: string, AmericanOnTaxSystem?: boolean | null, AnnualIncome: number, BankCode: string, Birthday?: string | null, BranchCode: string, BuildingNameRoomNumber?: string | null, CityCounty: string, Department?: string | null, DepositForm: number, FATCAAgreement?: boolean | null, FATCAOath?: boolean | null, FinancialAssets: number, FirstName: string, FirstNameKana: string, HomePhoneNumber?: string | null, ITIN?: string | null, IncomeForm: Array<number | null>, InsiderBoardMemberFirstName?: string | null, InsiderBoardMemberLastName?: string | null, InvestmentExperiences: Array<number | null>, InvestmentPolicy: number, InvestmentPurposes: Array<number | null>, LastName: string, LastNameKana: string, ListedCompanyCheck: boolean, ListedCompanyName?: string | null, ListedCompanyPost?: number | null, MailAddress?: string | null, MobilePhoneNumber: string, Nationality: number, OutSidePost?: string | null, Post?: string | null, PostCode: string, Prefecture: string, Profession: number, RetirementDate?: string | null, SSN?: string | null, Sex?: number | null, TownStreetAddress?: string | null, WorkPhoneNumber?: string | null, Workplace?: string | null } | null };

export type ChangeAccountInfoMutationVariables = Exact<{
  input?: InputMaybe<ChangeAccountInfoParam>;
}>;


export type ChangeAccountInfoMutation = { __typename?: 'Mutation', ChangeAccountInfo?: { __typename?: 'ChangeAccountInfoResult', Code: number, Message?: string | null, WithEKYC?: boolean | null } | null };

export type InquiryMutationVariables = Exact<{
  input?: InputMaybe<InquiryParam>;
}>;


export type InquiryMutation = { __typename?: 'Mutation', Inquiry?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountInfoQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', Account: string, ChangedPassword: boolean, DepositAmount: string, LastLoginDateTime?: string | null, MarginAmount: string, FinancialIntermediaryInvitation?: boolean | null, MFASetupStatus?: number | null } | null };

export type ReissuePasswordMutationVariables = Exact<{
  input?: InputMaybe<ReissuePasswordParam>;
}>;


export type ReissuePasswordMutation = { __typename?: 'Mutation', ReissuePassword?: { __typename?: 'ReissuePasswordResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type AgreeDocumentMutationVariables = Exact<{
  input?: InputMaybe<AgreeDocumentParam>;
}>;


export type AgreeDocumentMutation = { __typename?: 'Mutation', AgreeDocument?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAgreementDocumentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementDocumentQuery = { __typename?: 'Query', GetAgreementDocument?: { __typename?: 'AgreementDocumentList', Data?: Array<{ __typename?: 'AgreementDocumentInfo', Read: boolean, Type: number, URL: string } | null> | null } | null };

export type GetDateTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDateTimeQuery = { __typename?: 'Query', GetDateTime?: { __typename?: 'DateTimeInfo', Current?: string | null } | null };

export type GetAgreementDocumentListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementDocumentListQuery = { __typename?: 'Query', GetAgreementDocumentList?: { __typename?: 'AgreementDocumentList', Data?: Array<{ __typename?: 'AgreementDocumentInfo', Type: number, URL: string } | null> | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input?: InputMaybe<ChangePasswordParam>;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', ChangePassword?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetVirtualAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVirtualAccountInfoQuery = { __typename?: 'Query', GetVirtualAccountInfo?: { __typename?: 'VirtualAccountInfo', BankName: string, BankCode: string, BranchName: string, BranchCode: string, AccountNumber: string, AccountType: string, AccountHolder: string, AccountHolderKana: string } | null };

export type BrokerListItemFragment = { __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null };

export type GetBrokerInfoQueryVariables = Exact<{
  brokerName?: InputMaybe<Scalars['String']['input']>;
  brokerCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrokerInfoQuery = { __typename?: 'Query', GetBrokerInfo?: { __typename?: 'BrokerList', TotalCount: number, Data?: Array<{ __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null } | null> | null } | null };

export type GetBrokerBranchInfoQueryVariables = Exact<{
  brokerCode?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrokerBranchInfoQuery = { __typename?: 'Query', GetBrokerBranchInfo?: { __typename?: 'BrokerList', TotalCount: number, Data?: Array<{ __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null } | null> | null } | null };

export type GetOmegaFsSsoParamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOmegaFsSsoParamQuery = { __typename?: 'Query', GetOmegaFsSsoParam?: { __typename?: 'OmegaFsSsoParam', Kaiin: string, Buten: string, UserCd: string, ShoriYMD: string, ShoriHMS: string, GamenID: string, GamenParm: string, MenuDispFlg: string, ResultKensho: string } | null };

export type GetAccountTransactionHistoryQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetAccountTransactionHistoryQuery = { __typename?: 'Query', GetAccountTransactionHistory?: { __typename?: 'AccountTransactionHistory', TotalCount: number, Data?: Array<{ __typename?: 'AccountTransaction', ID: string, TransactionTypeName: string, TransactionDate: string, Debit?: string | null, Credit?: string | null, AmountPayment?: number | null, AmountDeposit?: number | null, AmountTransfer?: number | null, WithdrawalType?: number | null } | null> | null } | null };

export type UpdateAccountAssetMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateAccountAssetMutation = { __typename?: 'Mutation', UpdateAccountAsset?: { __typename?: 'AccountAssetInfo', DepositAmount: string, MarginAmount: string, WithdrawableAmount: string, TotalAssets: string, UpdTime: string, WithdrawalReservation?: string | null, WithdrawalCommission?: string | null, WithdrawalDay?: string | null, RefundAmount?: string | null, RefundCommission?: string | null, RefundDay?: string | null } | null };

export type RequestWithdrawalMutationVariables = Exact<{
  input?: InputMaybe<RequestWithdrawalParam>;
}>;


export type RequestWithdrawalMutation = { __typename?: 'Mutation', RequestWithdrawal?: { __typename?: 'RequestWithdrawalResult', Code: number, Message?: string | null, RequestedWithdrawalAmount: number, WithdrawalDate: string, WithdrawalAmount: number, Commission: number, PrevRequestedWithdrawalAmount?: number | null } | null };

export type CancelWithdrawalMutationVariables = Exact<{
  input?: InputMaybe<CancelWithdrawalParam>;
}>;


export type CancelWithdrawalMutation = { __typename?: 'Mutation', CancelWithdrawal?: { __typename?: 'RequestWithdrawalResult', Code: number, Message?: string | null, RequestedWithdrawalAmount: number, WithdrawalDate: string, WithdrawalAmount: number, Commission: number, PrevRequestedWithdrawalAmount?: number | null } | null };

export type GetNegotiateTokenQueryVariables = Exact<{
  account?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNegotiateTokenQuery = { __typename?: 'Query', GetNegotiateToken?: { __typename?: 'GetNegotiateTokenResult', Code: number, Message?: string | null, NegotiateToken?: string | null } | null };

export type GetListAuthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListAuthsQuery = { __typename?: 'Query', GetListAuths?: { __typename?: 'GetListAuthsResult', Code: number, Message?: string | null, AvailableAuthList?: Array<{ __typename?: 'AuthInfo', CredentialID: string, CreatedAt: string, AuthName?: string | null, IconData?: string | null, AAGUID?: string | null } | null> | null } | null };

export type MfaLoginMutationVariables = Exact<{
  input?: InputMaybe<MfaLoginParam>;
}>;


export type MfaLoginMutation = { __typename?: 'Mutation', MFALogin?: { __typename?: 'MFALoginResult', Code: number, Message?: string | null, PhoneNumber?: string | null, Token?: string | null } | null };

export type UpdateMfaSetupStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateMfaStatusParam>;
}>;


export type UpdateMfaSetupStatusMutation = { __typename?: 'Mutation', UpdateMFASetupStatus?: { __typename?: 'UpdateMFAStatusResult', Code: number, Message?: string | null } | null };

export const BrokerListItemFragmentDoc = gql`
    fragment BrokerListItem on BrokerInfo {
  BrokerCode
  BrokerName
  BranchCode
  BranchName
}
    `;
export const LoginDocument = gql`
    mutation Login($input: LoginParam) {
  Login(input: $input) {
    Code
    Message
    ProvisionalToken
    PhoneNumber
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  Logout {
    Code
    Message
  }
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const ReadNotificationDocument = gql`
    mutation ReadNotification($input: ReadNotificationParam) {
  ReadNotification(input: $input) {
    Code
    Message
  }
}
    `;

export function useReadNotificationMutation() {
  return Urql.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument);
};
export const SmsCertificateDocument = gql`
    mutation SMSCertificate($input: SMSCertificateParam) {
  SMSCertificate(input: $input) {
    Code
    Message
    Token
  }
}
    `;

export function useSmsCertificateMutation() {
  return Urql.useMutation<SmsCertificateMutation, SmsCertificateMutationVariables>(SmsCertificateDocument);
};
export const SendSmsDocument = gql`
    mutation SendSMS($input: SendSMSParam) {
  SendSMS(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useSendSmsMutation() {
  return Urql.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument);
};
export const GetSymbolListDocument = gql`
    query GetSymbolList($count: Int!, $page: Int!, $symbolName: String) {
  GetSymbolList(count: $count, page: $page, symbolName: $symbolName) {
    TotalCount
    Data {
      Symbol
      SymbolName
      ImageUrl
      Overview
      CurrentPrice
      PricePerUnit
      ExpectedInterestRate
      OperationStartDate
      OperationEndDate
      Tradable
      TradeStartDate
      TradeEndDate
    }
  }
}
    `;

export function useGetSymbolListQuery(options: Omit<Urql.UseQueryArgs<GetSymbolListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolListQuery, GetSymbolListQueryVariables>({ query: GetSymbolListDocument, ...options });
};
export const GetSymbolInfoDocument = gql`
    query GetSymbolInfo($symbol: String) {
  GetSymbolInfo(symbol: $symbol) {
    Symbol
    SymbolName
    ImageUrl
    Overview
    Explanation
    CurrentPrice
    PricePerUnit
    ExpectedInterestRate
    ProspectusUrl
    PreContractDocumentUrl
    OperationStartDate
    OperationEndDate
    Tradable
    TradeStartDate
    TradeEndDate
  }
}
    `;

export function useGetSymbolInfoQuery(options?: Omit<Urql.UseQueryArgs<GetSymbolInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolInfoQuery, GetSymbolInfoQueryVariables>({ query: GetSymbolInfoDocument, ...options });
};
export const ApplySymbolDocument = gql`
    mutation ApplySymbol($input: ApplySymbolParam) {
  ApplySymbol(input: $input) {
    Code
    Message
    AdditionalMessage
  }
}
    `;

export function useApplySymbolMutation() {
  return Urql.useMutation<ApplySymbolMutation, ApplySymbolMutationVariables>(ApplySymbolDocument);
};
export const OpenAccountDocument = gql`
    mutation OpenAccount($input: OpenAccountParam) {
  OpenAccount(input: $input) {
    Code
    Message
  }
}
    `;

export function useOpenAccountMutation() {
  return Urql.useMutation<OpenAccountMutation, OpenAccountMutationVariables>(OpenAccountDocument);
};
export const GetApplicationListDocument = gql`
    query GetApplicationList($count: Int!, $page: Int!, $symbolName: String) {
  GetApplicationList(count: $count, page: $page, symbolName: $symbolName) {
    TotalCount
    Data {
      ID
      LatestApplicationDateTime
      Status
      Symbol
      SymbolName
      TotalApplicationQuantity
      TotalPurchaseQuantity
      TotalPurchaseAmount
      LotteryFailureRefundType
    }
  }
}
    `;

export function useGetApplicationListQuery(options: Omit<Urql.UseQueryArgs<GetApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationListQuery, GetApplicationListQueryVariables>({ query: GetApplicationListDocument, ...options });
};
export const GetApplicationInfoDocument = gql`
    query GetApplicationInfo($id: String) {
  GetApplicationInfo(id: $id) {
    ID
    LatestApplicationDateTime
    Status
    Symbol
    SymbolName
    TotalApplicationQuantity
    TotalPurchaseQuantity
  }
}
    `;

export function useGetApplicationInfoQuery(options?: Omit<Urql.UseQueryArgs<GetApplicationInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationInfoQuery, GetApplicationInfoQueryVariables>({ query: GetApplicationInfoDocument, ...options });
};
export const GetNotificationListDocument = gql`
    query GetNotificationList($count: Int!, $page: Int!, $deliveryTarget: Int, $onlyNotConfirmed: Boolean) {
  GetNotificationList(
    count: $count
    page: $page
    deliveryTarget: $deliveryTarget
    onlyNotConfirmed: $onlyNotConfirmed
  ) {
    TotalCount
    Data {
      Confirmed
      DeliveryTarget
      DeliveryType
      ID
      PublishStartDate
      Title
      Importance
    }
  }
}
    `;

export function useGetNotificationListQuery(options: Omit<Urql.UseQueryArgs<GetNotificationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationListQuery, GetNotificationListQueryVariables>({ query: GetNotificationListDocument, ...options });
};
export const GetAddressInfoDocument = gql`
    query GetAddressInfo($postCode: String!) {
  GetAddressInfo(postCode: $postCode) {
    CityCounty
    Prefecture
    TownStreetAddress
  }
}
    `;

export function useGetAddressInfoQuery(options: Omit<Urql.UseQueryArgs<GetAddressInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAddressInfoQuery, GetAddressInfoQueryVariables>({ query: GetAddressInfoDocument, ...options });
};
export const GetNotificationInfoDocument = gql`
    query GetNotificationInfo($id: String!) {
  GetNotificationInfo(id: $id) {
    ConfirmDateTime
    Confirmed
    Contents
    DeliveryTarget
    DeliveryType
    ID
    PublishStartDate
    Title
    Importance
  }
}
    `;

export function useGetNotificationInfoQuery(options: Omit<Urql.UseQueryArgs<GetNotificationInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationInfoQuery, GetNotificationInfoQueryVariables>({ query: GetNotificationInfoDocument, ...options });
};
export const GetIssuanceDocumentListDocument = gql`
    query GetIssuanceDocumentList($count: Int!, $page: Int!, $documentType: Int) {
  GetIssuanceDocumentList(count: $count, page: $page, documentType: $documentType) {
    TotalCount
    Data {
      DisplayName
      FileName
      ID
      IssueDate
    }
  }
}
    `;

export function useGetIssuanceDocumentListQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentListQuery, GetIssuanceDocumentListQueryVariables>({ query: GetIssuanceDocumentListDocument, ...options });
};
export const GetIssuanceDocumentDocument = gql`
    query GetIssuanceDocument($id: String!) {
  GetIssuanceDocument(id: $id) {
    Data
  }
}
    `;

export function useGetIssuanceDocumentQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentQuery, GetIssuanceDocumentQueryVariables>({ query: GetIssuanceDocumentDocument, ...options });
};
export const GetBrokerMasterDocument = gql`
    query GetBrokerMaster($brokerCode: String!, $branchCode: String!) {
  GetBrokerMaster(brokerCode: $brokerCode, branchCode: $branchCode) {
    BranchCode
    BranchName
    BrokerCode
    BrokerName
  }
}
    `;

export function useGetBrokerMasterQuery(options: Omit<Urql.UseQueryArgs<GetBrokerMasterQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerMasterQuery, GetBrokerMasterQueryVariables>({ query: GetBrokerMasterDocument, ...options });
};
export const GetAccountDetailInfoDocument = gql`
    query GetAccountDetailInfo {
  GetAccountDetailInfo {
    AccountNumber
    AmericanOnTaxSystem
    AnnualIncome
    BankCode
    Birthday
    BranchCode
    BuildingNameRoomNumber
    CityCounty
    Department
    DepositForm
    FATCAAgreement
    FATCAOath
    FinancialAssets
    FirstName
    FirstNameKana
    HomePhoneNumber
    ITIN
    IncomeForm
    InsiderBoardMemberFirstName
    InsiderBoardMemberLastName
    InvestmentExperiences
    InvestmentPolicy
    InvestmentPurposes
    LastName
    LastNameKana
    ListedCompanyCheck
    ListedCompanyName
    ListedCompanyPost
    MailAddress
    MobilePhoneNumber
    Nationality
    OutSidePost
    Post
    PostCode
    Prefecture
    Profession
    RetirementDate
    SSN
    Sex
    TownStreetAddress
    WorkPhoneNumber
    Workplace
  }
}
    `;

export function useGetAccountDetailInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountDetailInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountDetailInfoQuery, GetAccountDetailInfoQueryVariables>({ query: GetAccountDetailInfoDocument, ...options });
};
export const ChangeAccountInfoDocument = gql`
    mutation ChangeAccountInfo($input: ChangeAccountInfoParam) {
  ChangeAccountInfo(input: $input) {
    Code
    Message
    WithEKYC
  }
}
    `;

export function useChangeAccountInfoMutation() {
  return Urql.useMutation<ChangeAccountInfoMutation, ChangeAccountInfoMutationVariables>(ChangeAccountInfoDocument);
};
export const InquiryDocument = gql`
    mutation Inquiry($input: InquiryParam) {
  Inquiry(input: $input) {
    Code
    Message
  }
}
    `;

export function useInquiryMutation() {
  return Urql.useMutation<InquiryMutation, InquiryMutationVariables>(InquiryDocument);
};
export const GetAccountInfoDocument = gql`
    query GetAccountInfo {
  GetAccountInfo {
    Account
    ChangedPassword
    DepositAmount
    LastLoginDateTime
    MarginAmount
    FinancialIntermediaryInvitation
    MFASetupStatus
  }
}
    `;

export function useGetAccountInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountInfoQuery, GetAccountInfoQueryVariables>({ query: GetAccountInfoDocument, ...options });
};
export const ReissuePasswordDocument = gql`
    mutation ReissuePassword($input: ReissuePasswordParam) {
  ReissuePassword(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useReissuePasswordMutation() {
  return Urql.useMutation<ReissuePasswordMutation, ReissuePasswordMutationVariables>(ReissuePasswordDocument);
};
export const AgreeDocumentDocument = gql`
    mutation AgreeDocument($input: AgreeDocumentParam) {
  AgreeDocument(input: $input) {
    Code
    Message
  }
}
    `;

export function useAgreeDocumentMutation() {
  return Urql.useMutation<AgreeDocumentMutation, AgreeDocumentMutationVariables>(AgreeDocumentDocument);
};
export const GetAgreementDocumentDocument = gql`
    query GetAgreementDocument {
  GetAgreementDocument {
    Data {
      Read
      Type
      URL
    }
  }
}
    `;

export function useGetAgreementDocumentQuery(options?: Omit<Urql.UseQueryArgs<GetAgreementDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgreementDocumentQuery, GetAgreementDocumentQueryVariables>({ query: GetAgreementDocumentDocument, ...options });
};
export const GetDateTimeDocument = gql`
    query GetDateTime {
  GetDateTime {
    Current
  }
}
    `;

export function useGetDateTimeQuery(options?: Omit<Urql.UseQueryArgs<GetDateTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDateTimeQuery, GetDateTimeQueryVariables>({ query: GetDateTimeDocument, ...options });
};
export const GetAgreementDocumentListDocument = gql`
    query GetAgreementDocumentList {
  GetAgreementDocumentList {
    Data {
      Type
      URL
    }
  }
}
    `;

export function useGetAgreementDocumentListQuery(options?: Omit<Urql.UseQueryArgs<GetAgreementDocumentListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgreementDocumentListQuery, GetAgreementDocumentListQueryVariables>({ query: GetAgreementDocumentListDocument, ...options });
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordParam) {
  ChangePassword(input: $input) {
    Code
    Message
  }
}
    `;

export function useChangePasswordMutation() {
  return Urql.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument);
};
export const GetVirtualAccountInfoDocument = gql`
    query GetVirtualAccountInfo {
  GetVirtualAccountInfo {
    BankName
    BankCode
    BranchName
    BranchCode
    AccountNumber
    AccountType
    AccountHolder
    AccountHolderKana
  }
}
    `;

export function useGetVirtualAccountInfoQuery(options?: Omit<Urql.UseQueryArgs<GetVirtualAccountInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVirtualAccountInfoQuery, GetVirtualAccountInfoQueryVariables>({ query: GetVirtualAccountInfoDocument, ...options });
};
export const GetBrokerInfoDocument = gql`
    query GetBrokerInfo($brokerName: String, $brokerCode: String) {
  GetBrokerInfo(brokerCode: $brokerCode, brokerName: $brokerName) {
    TotalCount
    Data {
      ...BrokerListItem
    }
  }
}
    ${BrokerListItemFragmentDoc}`;

export function useGetBrokerInfoQuery(options?: Omit<Urql.UseQueryArgs<GetBrokerInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerInfoQuery, GetBrokerInfoQueryVariables>({ query: GetBrokerInfoDocument, ...options });
};
export const GetBrokerBranchInfoDocument = gql`
    query GetBrokerBranchInfo($brokerCode: String, $branchCode: String, $branchName: String) {
  GetBrokerBranchInfo(
    brokerCode: $brokerCode
    branchCode: $branchCode
    branchName: $branchName
  ) {
    TotalCount
    Data {
      ...BrokerListItem
    }
  }
}
    ${BrokerListItemFragmentDoc}`;

export function useGetBrokerBranchInfoQuery(options?: Omit<Urql.UseQueryArgs<GetBrokerBranchInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerBranchInfoQuery, GetBrokerBranchInfoQueryVariables>({ query: GetBrokerBranchInfoDocument, ...options });
};
export const GetOmegaFsSsoParamDocument = gql`
    query GetOmegaFsSsoParam {
  GetOmegaFsSsoParam {
    Kaiin
    Buten
    UserCd
    ShoriYMD
    ShoriHMS
    GamenID
    GamenParm
    MenuDispFlg
    ResultKensho
  }
}
    `;

export function useGetOmegaFsSsoParamQuery(options?: Omit<Urql.UseQueryArgs<GetOmegaFsSsoParamQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOmegaFsSsoParamQuery, GetOmegaFsSsoParamQueryVariables>({ query: GetOmegaFsSsoParamDocument, ...options });
};
export const GetAccountTransactionHistoryDocument = gql`
    query GetAccountTransactionHistory($count: Int!, $page: Int!) {
  GetAccountTransactionHistory(count: $count, page: $page) {
    TotalCount
    Data {
      ID
      TransactionTypeName
      TransactionDate
      Debit
      Credit
      AmountPayment
      AmountDeposit
      AmountTransfer
      WithdrawalType
    }
  }
}
    `;

export function useGetAccountTransactionHistoryQuery(options: Omit<Urql.UseQueryArgs<GetAccountTransactionHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountTransactionHistoryQuery, GetAccountTransactionHistoryQueryVariables>({ query: GetAccountTransactionHistoryDocument, ...options });
};
export const UpdateAccountAssetDocument = gql`
    mutation UpdateAccountAsset {
  UpdateAccountAsset {
    DepositAmount
    MarginAmount
    WithdrawableAmount
    TotalAssets
    UpdTime
    WithdrawalReservation
    WithdrawalCommission
    WithdrawalDay
    RefundAmount
    RefundCommission
    RefundDay
  }
}
    `;

export function useUpdateAccountAssetMutation() {
  return Urql.useMutation<UpdateAccountAssetMutation, UpdateAccountAssetMutationVariables>(UpdateAccountAssetDocument);
};
export const RequestWithdrawalDocument = gql`
    mutation RequestWithdrawal($input: RequestWithdrawalParam) {
  RequestWithdrawal(input: $input) {
    Code
    Message
    RequestedWithdrawalAmount
    WithdrawalDate
    WithdrawalAmount
    Commission
    PrevRequestedWithdrawalAmount
  }
}
    `;

export function useRequestWithdrawalMutation() {
  return Urql.useMutation<RequestWithdrawalMutation, RequestWithdrawalMutationVariables>(RequestWithdrawalDocument);
};
export const CancelWithdrawalDocument = gql`
    mutation CancelWithdrawal($input: CancelWithdrawalParam) {
  CancelWithdrawal(input: $input) {
    Code
    Message
    RequestedWithdrawalAmount
    WithdrawalDate
    WithdrawalAmount
    Commission
    PrevRequestedWithdrawalAmount
  }
}
    `;

export function useCancelWithdrawalMutation() {
  return Urql.useMutation<CancelWithdrawalMutation, CancelWithdrawalMutationVariables>(CancelWithdrawalDocument);
};
export const GetNegotiateTokenDocument = gql`
    query GetNegotiateToken($account: String) {
  GetNegotiateToken(account: $account) {
    Code
    Message
    NegotiateToken
  }
}
    `;

export function useGetNegotiateTokenQuery(options?: Omit<Urql.UseQueryArgs<GetNegotiateTokenQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNegotiateTokenQuery, GetNegotiateTokenQueryVariables>({ query: GetNegotiateTokenDocument, ...options });
};
export const GetListAuthsDocument = gql`
    query GetListAuths {
  GetListAuths {
    Code
    Message
    AvailableAuthList {
      CredentialID
      CreatedAt
      AuthName
      IconData
      AAGUID
    }
  }
}
    `;

export function useGetListAuthsQuery(options?: Omit<Urql.UseQueryArgs<GetListAuthsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetListAuthsQuery, GetListAuthsQueryVariables>({ query: GetListAuthsDocument, ...options });
};
export const MfaLoginDocument = gql`
    mutation MFALogin($input: MFALoginParam) {
  MFALogin(input: $input) {
    Code
    Message
    PhoneNumber
    Token
  }
}
    `;

export function useMfaLoginMutation() {
  return Urql.useMutation<MfaLoginMutation, MfaLoginMutationVariables>(MfaLoginDocument);
};
export const UpdateMfaSetupStatusDocument = gql`
    mutation UpdateMFASetupStatus($input: UpdateMFAStatusParam) {
  UpdateMFASetupStatus(input: $input) {
    Code
    Message
  }
}
    `;

export function useUpdateMfaSetupStatusMutation() {
  return Urql.useMutation<UpdateMfaSetupStatusMutation, UpdateMfaSetupStatusMutationVariables>(UpdateMfaSetupStatusDocument);
};